import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, subtitle, word = "MAS" }) {
  return (
    <section className="relative bg-[#0A0A0A] text-white overflow-hidden">
      <span className="pointer-events-none select-none absolute -right-8 top-2 font-display font-900 text-[13rem] md:text-[17rem] leading-none text-white/[0.04]" style={{ fontWeight: 900 }}>{word}</span>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-24">
        {eyebrow && <motion.span initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="text-xs font-bold uppercase tracking-[0.25em] text-white/45 block">{eyebrow}</motion.span>}
        <motion.h1 initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.05 }} className="font-display font-900 text-5xl md:text-7xl tracking-tight mt-4 max-w-3xl leading-[0.92]" style={{ fontWeight: 900 }}>{title}</motion.h1>
        {subtitle && <motion.p initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.12 }} className="text-white/60 mt-5 text-lg max-w-2xl">{subtitle}</motion.p>}
      </div>
    </section>
  );
}
